import type { TOC } from '@ember/component/template-only';
import ModalPropertyAccess from 'lumen/components/settings/users/modals/modal-property-access';
import type HotelSettingsUsersPropertyAccessController from 'lumen/controllers/hotel/settings/users/property-access';

interface HotelSettingsUsersPropertyAccessSignature {
  Args: {
    controller: HotelSettingsUsersPropertyAccessController;
  };
}

const HotelSettingsUsersPropertyAccess: TOC<HotelSettingsUsersPropertyAccessSignature> =
  <template>
    <ModalPropertyAccess
      @onClose={{@controller.close}}
      @onSave={{@controller.saveChanges}}
      @relationships={{@controller.model}}
      @userEmail={{@controller.userEmail}}
      @userId={{@controller.userId}}
    />
  </template>;

export default HotelSettingsUsersPropertyAccess;
